import ApiService from "./api.service";
export default class CalendarManagementService extends ApiService {
    static base_url = `${super.base_url}/calendars_managements`;
}
